export const MOBILE_BREAKPOINT = 900;
export const MOBILE_RESPONSIVE = `max-[${MOBILE_BREAKPOINT}px]`;
export const DESKTOP_RESPONSIVE = `min-[${MOBILE_BREAKPOINT + 1}px]`;
import { CustomThemeType } from "../theme";

export const filterEnabledOverrides = (
  overrides: { [key: string]: CustomThemeType } = {}
) => {
  return Object.keys(overrides).reduce((acc, key) => {
    const style = overrides[key];
    if (style?.enabled) {
      acc[key] = style;
    }
    return acc;
  }, {} as { [key: string]: CustomThemeType });
};
